import { render, staticRenderFns } from "./Step3_Contract2.vue?vue&type=template&id=2897e8b8&"
import script from "./Step3_Contract2.vue?vue&type=script&lang=js&"
export * from "./Step3_Contract2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports